<template>
  <div class="input-number gray-page">
    <div class="input-label">
      <div class="label">输入编号</div>
      <input type="text" v-model="cup_sn" placeholder="请输入您的水杯编号" />
    </div>
    <Btn title="下一步" @click="handle" v-if="id === 0" />
    <Btn title="重新绑定" @click="handle" v-else />
  </div>
</template>

<script>
  export default {
    data () {
      return {
        cup_sn: '',
        id: 0
      }
    },
    methods: {
      handle () {
        if (this.cup_sn) {
          if (this.id) {
            this.CupReBindCup()
          } else {
            this.Gonav()
          }
        } else {
          this.$ShowToast('请输入编号')
        }
      },
      Gonav () {
        this.$nav('Common.AddForm', { cup_sn: this.cup_sn })
      },
      CupReBindCup () {
        this.$Post('Common.CupReBindCup', {
          cup_id: this.id,
          cup_sn: this.cup_sn
        }).then(res => {
          this.$ShowToast(res.msg, { icon: 'success' }).then(() => {
            this.$nav('back')
          })
        })
      }
    },
    created () {
      this.id = this.$route.query.id * 1
    }
  }
</script>

<style lang="less" scoped>
  .input-number {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .p(.3rem .24rem .9rem);
    .input-label {
      .br(.1rem);
      .bg(#fff);
      .h(1.1rem);
      align-items: baseline;
      display: flex;
      align-items: center;
      .p(0 .3rem);
      .label {
        .fz(.3rem);
        .c(#333);
        .mr(.4rem);
      }
      input {
        flex: 1;
      }
    }
  }
</style>
